import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { StandardTriageRecommendationPageConsultationClickedEventTracking } from '@/modules/auth/models/segmentevents/StandardTriageRecommendationPageConsultationClickedEventTracking';

export class StandardTriageRecommendationPageConsultationBookedEventTracking extends StandardTriageRecommendationPageConsultationClickedEventTracking {
  static eventName: SegmentEvent =
    SegmentEvent.STANDARD_TRIAGE_RECOMMENDATION_PAGE_CONSULTATION_BOOKED;
  consultation_booked: boolean;

  constructor(
    eventProperties: Partial<StandardTriageRecommendationPageConsultationClickedEventTracking>,
    type: string
  ) {
    super(eventProperties, type);
    this.consultation_booked = true;
  }
}
